import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext } from '../../context/ModalContext';
import CancelIcon from '../Icons/CancelIcon';

interface IModalContentWrapper {
  width: string;
  title?: string | null;
  description?: string;
  children: React.ReactNode;
  removeCancelIcon?: boolean;
  customToggler?: (...args: any[]) => void;
}
export const ModalContentWrapper: React.FC<IModalContentWrapper> = ({
  width,
  title,
  description,
  children,
  removeCancelIcon = false,
  customToggler,
}) => {
  const modalContext = useContext(ModalContext);
  const onClickCancel = (e: any) => {
    modalContext?.displayModal(false);
  };

  return (
    <Container
      width={width}
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <>
        <div>
          <HeaderSection>
            <Label>{title}</Label>
            <CancelButtonWrapper
              className={removeCancelIcon === true ? 'removeCancelIcon' : ''}
              onClick={customToggler ? customToggler : onClickCancel}
            >
              <CancelIconWrapper>
                <CancelIcon />
              </CancelIconWrapper>
            </CancelButtonWrapper>
          </HeaderSection>
          <Description>{description}</Description>
        </div>
        {children}
      </>
    </Container>
  );
};

const Description = styled.div`
  margin-top: -0.3rem;
`;

const CancelIconWrapper = styled.div`
  /* border: 1px solid red; */
  cursor: pointer;
`;
interface IContainerWidth {
  width: string;
}

const Container = styled.div<IContainerWidth>`
  display: flex;
  flex-direction: column;
  padding: 3.63rem 2.5rem;
  border-radius: 0.25rem;
  background-color: white;
  width: ${({ width }) => width};
  gap: 2rem;

  /* border: 2px solid blue; */

  @media (max-width: 480px) {
    /* border: 2px solid red; */
    width: 100vw;
    height: 100vh;
    padding: 3.63rem 1rem;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Label = styled.div`
  color: #1f2130;
  font-size: 1.125rem;
  font-weight: 500;
`;

const CancelButtonWrapper = styled.div`
  &.removeCancelIcon {
    @media (max-width: 480px) {
      display: none;
    }
  }
`;
